**Pillage First! (Ask Questions Later)** is an **open-source**, **single-player**, **strategy game** inspired by
Travian.

**Build villages**, **manage resources**, **train troops**, **start adventures** and **wage war** in **persistent**,
**offline-first** game worlds.

Pillage First! requires no account or download. We strive to offer a **more customizable** and **time-friendly** alternative to Travian.
